/**
 * Super Admin Route Protection
 *
 * Wraps routes that should only be accessible to super admin users.
 * Redirects to home page if user is not a super admin.
 */

import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppStore } from '~/store';

interface SuperAdminRouteProps {
  children: ReactNode;
}

export const SuperAdminRoute: FC<SuperAdminRouteProps> = ({ children }) => {
  const userInfo = useAppStore((s) => s.userInfo);
  const isSuperAdmin = userInfo?.isSuperAdmin ?? false;

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
